import { DEFAULT_ALTERNATE_NAME, MAIN_DOMAIN } from 'globalConstants';

const IntroduceAndContact = () => (
  <div className='flex w-full flex-col space-y-[24px]'>
    <h1 className='text-[24px] font-[600] leading-[30px]' id='gioi-thieu-va-lien-he'>
      1. Giới thiệu và liên hệ
    </h1>
    <div className='flex w-full flex-col space-y-[12px]'>
      <h2 className='text-[16px] font-[600] uppercase' id='gioi-thieu'>
        1.1 Giới thiệu
      </h2>
      <span className='text-[14px] leading-[24px]'>
        Là sàn giao dịch thương mại điện tử <b>{DEFAULT_ALTERNATE_NAME}</b> (sau đây gọi là{' '}
        <b>{DEFAULT_ALTERNATE_NAME}</b>) do Công ty Cổ phần truyền thông bất động sản công nghệ làm
        chủ sở hữu. <b>{DEFAULT_ALTERNATE_NAME}</b> là sàn giao dịch thương mại điện tử cung cấp
        thông tin bất động sản, dịch vụ bất động sản trong và ngoài nước cho cá nhân, tổ chức có nhu
        cầu về bất động sản và các dịch vụ khác liên quan đến bất động sản.
      </span>
      <span className='text-[14px] leading-[24px]'>
        <b>{DEFAULT_ALTERNATE_NAME}</b> là công ty Dịch vụ Bất động sản, hoạt động trên nền tảng
        công nghệ hiện đại và thông minh; tổng hợp nguồn dữ liệu khổng lồ về thị trường mua – bán
        bất động sản tại 63 tỉnh thành, tối ưu hóa công sức, tiền, thời gian của khách hàng, mang
        đến những trải nghiệm giá trị thực, nhanh chóng hiệu quả cho ngành bất động sản, liên tục
        cập nhật thông tin và công nghệ mới nhất. <b>{DEFAULT_ALTERNATE_NAME}</b> với bề dày kinh
        nghiệm về lĩnh vực công nghệ thông tin và bất động sản, hội tựu các chuyên gia hàng đầu về
        tư vấn luật, tư vấn tài chính, công nghệ, bất động sản, trong các dịch vụ của{' '}
        <b>{DEFAULT_ALTERNATE_NAME}</b> mang đến tiện ích luôn đồng hành cùng khách hàng.
      </span>
    </div>
    <div className='flex w-full flex-col space-y-[24px]'>
      <h2 id='cac-dich-vu-chinh' className='text-[16px] font-[600] uppercase'>
        1.2 Các dịch vụ chính
      </h2>
      <div className='flex w-full flex-col text-[14px] leading-[24px]'>
        <span>- Đăng tin quảng cáo bất động sản, cập nhật tin tức thị trường.</span>
        <span>
          - Xem Định giá bất động sản, hỗ trợ vay tài chính, tư vấn luật, tư vấn xây dựng.
        </span>
        <span>- Tra cứu thông tin bất động sản nhanh & Đăng bài PR quảng bá sản phẩm dịch vụ.</span>
        <span>- Danh bạ doanh nghiệp, nhà môi giới BĐS.</span>
      </div>
    </div>
    <div className='flex w-full flex-col space-y-[24px]'>
      <h2 id='lien-he' className='text-[16px] font-[600] uppercase'>
        1.3 Liên hệ
      </h2>
      <div className='flex w-full flex-col text-[14px] leading-[24px]'>
        <span>Công ty Cổ phần truyền thông bất động sản công nghệ</span>
        <span>Trụ sở chính tại Thành phố Hồ Chí Minh</span>
        <span>
          Điện thoại - Tổng đài CSKH:{' '}
          <a href='tel:+0789333322' className='font-[600] text-primary underline'>
            0789 333 322
          </a>
        </span>
        <span>
          Email:{' '}
          <a href='mailto:contact@atmnha.vn' className='font-[600] text-primary underline'>
            contact@atmnha.vn
          </a>
        </span>
        <span>
          Website:{' '}
          <a href={`${MAIN_DOMAIN}`} className='font-[600] text-primary underline'>
            {MAIN_DOMAIN}
          </a>
        </span>
      </div>
    </div>
    <div className='flex w-full flex-col space-y-[24px]'>
      <h2 id='bao-gia-va-ho-tro' className='text-[16px] font-[600] uppercase'>
        1.4 Bạn cần báo giá và hỗ trợ hoặc có câu hỏi cần chúng tôi trợ giúp
      </h2>
      <div className='flex w-full flex-col text-[14px] leading-[24px]'>
        <span>
          Vui lòng tham khảo{' '}
          <strong className='text-primary underline underline-offset-2'>
            {' '}
            NHỮNG CÂU HỎI THƯỜNG GẶP{' '}
          </strong>
          . Nếu không tìm thấy giải pháp cho vấn đề của bạn, hãy liên hệ
          <b> ATM nhà</b> theo thông tin dưới đây:
        </span>
      </div>
    </div>
    <div className='h-[5px] w-full border-y border-dashed' />
  </div>
);

export default IntroduceAndContact;
